import React, { useEffect } from 'react';
import moment from 'moment';
const DownloadCodeHistory = ({
  exportId,
  projectId,
  codeDownloadHistories,
  loadDownloadCodeHistory,
}) => {
  useEffect(() => {
    loadDownloadCodeHistory({ projectId, exportId });
  }, [exportId, projectId]);

  return (
    <table className="table table-bordered table-hover">
      <tbody>
        {codeDownloadHistories.map((history) => (
          <tr>
            <td>{moment(history.createdAt).format('Do MMM YYYY hh:mm:ss A')}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DownloadCodeHistory;
